import React from "react";

const ScopeIcon = ({ stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 19.567 19.259"
    >
      <g
        data-name="Grupo 2690"
        transform="translate(1.35 1.35)"
        fill="none"
        stroke={stroke}
        strokeMiterlimit={10}
        strokeWidth={2.7}
      >
        <circle data-name="Elipse 15" cx={6.01} cy={6.01} r={6.01} />
        <path
          data-name="L\xEDnea 18"
          strokeLinecap="round"
          d="M16.307 16l-5.897-5.897"
        />
      </g>
    </svg>
  );
};

export default ScopeIcon;
